import request from './adminRequest'

export const commentPermissionApi = {
  listCommentPermission () {
    return request.get('/commentPermissions')
  },
  saveCommentPermission (data) {
    return request.post('/commentPermissions', data)
  },
  deleteCommentPermission (uid) {
    return request.delete('/commentPermissions/' + uid)
  },
}
export default commentPermissionApi
